module.exports = __webpack_public_path__ + "biao19.gif?1261753";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao19.gif
 ** module id = 54
 ** module chunks = 0
 **/